<template>
    <div class="container mt-3">
        <h1 class="text-center">Hot Takes</h1>
        <DataLoader>
            <template v-slot:default="{ model }">
                <div v-if="model && updateModel(model)">
                    <div class="h3 text-center">
                        Spendenstand
                        <CountUpDecimal :targetValue="HotTakesSummary.TotalDonations" :animationTime="1000" :waitFor="0"
                            class="text-success bold" suffix="€" />
                    </div>
                    <div class="form-check form-switch mb-4" style="margin-left:12px;">
                        <input class="form-check-input cursor-pointer" type="checkbox" id="nullChecked"
                            v-model="onlyHb" />
                        <label class="form-check-label cursor-pointer bold" style="user-select: none;"
                            for="nullChecked">Nur Hertha BASE Mitglieder</label>
                    </div>
                    <table class="table table-hover ">
                        <thead>
                            <tr class="table-light">
                                <th style="text-align:end;">Spendenbetrag</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(usr, index) in HotTakesSummary.HotTakesByUser" :key="index">
                                <template v-if="!onlyHb || (onlyHb && usr.IsHbMember)">
                                    <tr class="table-dark">
                                        <td class="user-header-cell">
                                            <div class="d-flex align-items-center gap-2">
                                                <img src="/hb-icon.png" v-if="usr.IsHbMember" class="rounded-circle"
                                                    width="30" height="30" />
                                                <ProgressCircle :percent="usr.SuccessRateInPct" :size="28"
                                                    class="text-white" />
                                                <a :href="'/user/' + usr.Slug" class="text-white bold">{{ usr.Username
                                                    }}</a>
                                            </div>
                                            <span class="user-donation">{{ usr.TotalDonations }} €</span>
                                        </td>
                                    </tr>
                                    <tr v-for="(bet, betIndex) in usr.HotTakes" :key="betIndex">
                                        <td class="bet-single-cell">
                                            <div class="bet-str">
                                                <template v-if="bet.Occured === 0">
                                                    <font-awesome-icon icon="circle-xmark" class="text-danger" />
                                                </template>
                                                <template v-else-if="bet.Occured == null">
                                                    <font-awesome-icon icon="circle-question" class="text-warning" />
                                                </template>
                                                <template v-else-if="bet.Occured > 0">
                                                    <font-awesome-icon icon="check" class="text-success" />
                                                </template>
                                                <span>&nbsp;{{ bet.BetStr }}</span>
                                            </div>
                                            <div class="bet-amount-wrapper">
                                                <span :class="{
                                                    'text-success': bet.Occured > 0,
                                                    'text-muted': bet.Occured == null,
                                                    'text-danger': bet.Occured === 0
                                                }" class="bet-amount text-end">
                                                    {{ bet.BetPerOccurrence }} €
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                </template>
                            </template>
                        </tbody>
                    </table>
                </div>
                <div class="float-right"><a href="/mitmachen">Mitmachen</a></div>
            </template>
        </DataLoader>
    </div>
</template>

<style scoped>
.user-header-cell {
    position: relative;
    padding-right: 40px;
    /* Platz lassen für Betrag */
    vertical-align: middle;
}

.user-donation {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    white-space: nowrap;
    font-weight: bold;
    color: #198754;
    /* Bootstrap text-success */
}

.bet-single-cell {
    position: relative;
    width: 100%;
    word-break: break-word;
    padding-right: 80px;
    /* Platz für Betrag rechts schaffen */
    vertical-align: top;
}

.bet-str {
    white-space: normal;
}

.bet-amount-wrapper {
    position: absolute;
    top: 0;
    right: 10px;
    white-space: nowrap;
}

.bet-amount {
    font-weight: bold;
}
</style>

<script>
import CountUpDecimal from "../components/core/CountUpDecimal.vue";
import DataLoader from "../components/DataLoader.vue";
import ProgressCircle from "../components/core/ProgressCircle.vue";
//import { toast } from 'vue3-toastify';

export default {
    components: { DataLoader, CountUpDecimal, ProgressCircle },
    async mounted() {
        console.log('mounted');
    },
    data() {
        return {
            model: null,
            onlyHb: false,

        };
    },
    methods: {
        updateModel(model) {
            if (this.model !== model) {
                this.model = model;
            }
            return true;
        },
        formatNumber(num) {
            return num.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        }
    },
    computed: {
        HotTakesSummary() {

            console.log('computed');

            if (!this.model || !this.model.AllBets) {
                return {
                    TotalBets: 0,
                    TotalDonations: 0,
                    HotTakesByUser: []
                };
            }


            const hotTakes = this.model.AllBets.filter(bet => bet.BetTypeId === 5);

            // Step 2: Aggregate totals
            const TotalBets = hotTakes.length;
            const TotalDonations = hotTakes.reduce((sum, bet) => sum + bet.TotalBetAmount, 0);

            // Step 3: Group by Username
            const grouped = {};
            hotTakes.forEach(bet => {
                if (!grouped[bet.Username]) {
                    grouped[bet.Username] = [];
                }
                grouped[bet.Username].push(bet);
            });

            // Step 4: Build HotTakesByUser
            const HotTakesByUser = Object.entries(grouped).map(([username, bets]) => {
                // Sortiere die Bets des Users nach TotalBetAmount absteigend
                const sortedBets = bets.sort((a, b) => b.TotalBetAmount - a.TotalBetAmount);

                const totalDonations = sortedBets.reduce((sum, bet) => sum + bet.TotalBetAmount, 0);
                const isHbMember = sortedBets[0].IsHbMember;
                const slug = sortedBets[0].Slug;
                const relevant = sortedBets.filter(b => b.Occured != null);
                const successCount = relevant.filter(b => b.Occured > 0).length;
                const successRate = relevant.length > 0 ? (successCount / relevant.length) * 100 : 0;

                return {
                    Username: username,
                    TotalDonations: totalDonations,
                    IsHbMember: isHbMember,
                    Slug: slug,
                    SuccessRateInPct: successRate,
                    HotTakes: sortedBets
                };
            }).sort((a, b) => b.TotalDonations - a.TotalDonations); // Sortiere Users nach Spendenbetrag

            return {
                TotalBets,
                TotalDonations,
                HotTakesByUser
            };
        }
    }
}
</script>